export const AvatarImg = ({ avatarURI }: { avatarURI: string }) => <img src={avatarURI} alt="avatar" />;
